<template>
  <transition name="fade">
    <div class="launch-confirmation-wrapper">
      <div class="launch-confirmation-overlay" :class="{ show: isOpen }" @click="$emit('close')" />
      <transition name="fade">
        <div v-if="isOpen" class="launch-confirmation">
          <div class="launch-confirmation-container">
            <div class="warn-block">
              <h2>Vous êtes prêt à jouer ?</h2>
              <p class="text">
                Yuzu est spécialisé dans l’évaluation des soft skills à travers le <b>jeu vidéo</b>. Vous allez entrer dans un
                univers qui mettra à l’épreuve vos différentes compétences !
                <br /><br />
                Avant de vous connecter au jeu, nous allons réaliser quelques <b>tests de compatibilité technique</b>.
                <br />Rassurez-vous, ces tests sont entièrement automatisés, et nous vous <b>guiderons pas-à-pas</b> si nécessaire.
                <br /><br />
                Pour commencer, assurez-vous d’utiliser un <b>ordinateur branché au secteur</b> et une <b>connexion Internet
                stable à haut débit</b> à partir de la France ou d’un pays limitrophe.
              </p>
            </div>
            <div class="warn-block inline">
              <Button class="outline light" label="Revenir plus tard" @click="$emit('close')" />
              <Button class="primary" label="Continuer" :loading="state.isLoading" @click="startSession()" />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.launch-confirmation-wrapper .launch-confirmation {
  max-width: 1460px;

  padding: 80px 2px 80px 80px;

  border-radius: 12px;
  border: 2px solid #464646;
  background: #1D1D1D;

  .text {
    font-size: 18px;
  }

  b {
    font-weight: 700;
    color: #F2CB36;
  }
}
</style>

<script setup>
import { watch, reactive } from "vue";
import { useRouter } from "vue-router";
import { useCloudClientStore } from "@/stores/cloud-client";

const router = useRouter();
const cloudClient = useCloudClientStore();

defineEmits(["close"]);

const state = reactive({
  isMounted: false,
  isLoading: false,
});

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

watch(props, () => {
  if (props.isOpen) {
    setTimeout(() => {
      state.isMounted = true;
    }, 300);
  }
});

async function startSession() {
  if (state.isLoading) return;
  state.isLoading = true;
  if (await cloudClient.startSession()) {
    state.isLoading = false;
    router.push({ name: "game-waiting" });
  }
}
</script>
